/* eslint-disable import/prefer-default-export */
import { API_URL } from '../../../../utils/config';

export const GET_LOGS_URL = `${API_URL}/users/logs`;
